export const Link = "https://narbapis.rosoftsavvy.app";
// export const Link = "http://localhost:5000";
